var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _g3, _path17, _path18, _path19, _path20, _path21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaterDrinking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 150,
    viewBox: "0 0 265 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 108L24.5 104",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114 108C140.51 108 162 86.5097 162 60C162 33.4903 140.51 12 114 12C87.4903 12 66 33.4903 66 60C66 86.5097 87.4903 108 114 108Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118 140C146.719 140 170 116.719 170 88C170 59.2812 146.719 36 118 36C89.2812 36 66 59.2812 66 88C66 116.719 89.2812 140 118 140Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146 150C174.719 150 198 126.719 198 98C198 69.2812 174.719 46 146 46C117.281 46 94 69.2812 94 98C94 126.719 117.281 150 146 150Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162 129C190.719 129 214 105.719 214 77C214 48.2812 190.719 25 162 25C133.281 25 110 48.2812 110 77C110 105.719 133.281 129 162 129Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149 102C175.51 102 197 80.5097 197 54C197 27.4903 175.51 6 149 6C122.49 6 101 27.4903 101 54C101 80.5097 122.49 102 149 102Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 78,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 64,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 142,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 135.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 7.5,
    r: 1.5,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.965 87.5021C175.187 92.7385 174.343 97.9655 172.485 102.869C170.627 107.772 167.792 112.25 164.152 116.033C160.512 119.816 156.142 122.827 151.304 124.883C146.465 126.94 141.26 128 136 128C130.74 128 125.535 126.94 120.697 124.883C115.859 122.827 111.488 119.816 107.848 116.033C104.208 112.25 101.373 107.772 99.515 102.869C97.6567 97.9655 96.813 92.7385 97.0346 87.5021C97.0346 53.5422 135.688 24 135.688 24C135.688 24 174.965 53.5422 174.965 87.5021Z",
    fill: "#D9F2FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11304_9724",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 24,
    width: 78,
    height: 104
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.965 87.5021C175.187 92.7385 174.343 97.9655 172.485 102.869C170.627 107.772 167.792 112.25 164.152 116.033C160.512 119.816 156.142 122.827 151.304 124.883C146.465 126.94 141.26 128 136 128C130.74 128 125.535 126.94 120.697 124.883C115.859 122.827 111.488 119.816 107.848 116.033C104.208 112.25 101.373 107.772 99.515 102.869C97.6567 97.9655 96.813 92.7385 97.0346 87.5021C97.0346 53.5422 135.688 24 135.688 24C135.688 24 174.965 53.5422 174.965 87.5021Z",
    fill: "#77D3FA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11304_9724)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M44.9559 49.1071L29.8455 42.9685C26.6454 41.6685 23.224 41 19.7699 41C4.9853 41 -7 52.9853 -7 67.7699V113C-7 130.673 7.32689 145 25 145H217C234.673 145 249 130.673 249 113V67.7699C249 52.9853 237.015 41 222.23 41C218.776 41 215.355 41.6685 212.154 42.9685L197.044 49.1071C189.321 52.2445 180.679 52.2445 172.956 49.1071L165.044 45.8929C157.321 42.7555 148.679 42.7555 140.956 45.8929L133.044 49.1071C125.321 52.2445 116.679 52.2445 108.956 49.1071L101.044 45.8929C93.3212 42.7555 84.6788 42.7555 76.9559 45.8929L69.0441 49.1071C61.3212 52.2445 52.6788 52.2445 44.9559 49.1071Z",
    fill: "#77D3FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M52.9559 75.1071L37.8455 68.9685C34.6454 67.6685 31.224 67 27.7699 67C12.9853 67 1 78.9853 1 93.7699V139C1 156.673 15.3269 171 33 171H225C242.673 171 257 156.673 257 139V93.7699C257 78.9853 245.015 67 230.23 67C226.776 67 223.355 67.6685 220.154 68.9685L205.044 75.1071C197.321 78.2445 188.679 78.2445 180.956 75.1071L173.044 71.8929C165.321 68.7555 156.679 68.7555 148.956 71.8929L141.044 75.1071C133.321 78.2445 124.679 78.2445 116.956 75.1071L109.044 71.8929C101.321 68.7555 92.6788 68.7555 84.9559 71.8929L77.0441 75.1071C69.3212 78.2445 60.6788 78.2445 52.9559 75.1071Z",
    fill: "#77D3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9559 101.107L45.8455 94.9685C42.6454 93.6685 39.224 93 35.7699 93C20.9853 93 9 104.985 9 119.77V165C9 182.673 23.3269 197 41 197H233C250.673 197 265 182.673 265 165V119.77C265 104.985 253.015 93 238.23 93C234.776 93 231.355 93.6685 228.154 94.9685L213.044 101.107C205.321 104.245 196.679 104.245 188.956 101.107L181.044 97.8929C173.321 94.7555 164.679 94.7555 156.956 97.8929L149.044 101.107C141.321 104.245 132.679 104.245 124.956 101.107L117.044 97.8929C109.321 94.7555 100.679 94.7555 92.9559 97.8929L85.0441 101.107C77.3212 104.245 68.6788 104.245 60.9559 101.107Z",
    fill: "#A1E1FB"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114 94C114.345 97.2766 116.828 104.664 124 108",
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115 76C115 76 114 77 114 79",
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11304_9724)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M216.696 52.3326C216.569 55.1519 215.871 57.9161 214.644 60.459C213.417 63.0019 211.687 65.2708 209.557 67.1294C207.427 68.988 204.941 70.3977 202.249 71.2739C199.557 72.15 196.715 72.4744 193.894 72.2275C191.072 71.9807 188.33 71.1677 185.831 69.8375C183.333 68.5072 181.129 66.6873 179.354 64.487C177.579 62.2868 176.269 59.7518 175.502 57.0345C174.736 54.3172 174.528 51.4738 174.893 48.6753C176.487 30.4588 198.607 16.426 198.607 16.426C198.607 16.426 218.29 34.1161 216.696 52.3326Z",
    fill: "#D9F2FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11304_9724",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 16,
    width: 43,
    height: 57
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M216.695 52.3316C216.568 55.1509 215.87 57.9151 214.643 60.458C213.416 63.0009 211.686 65.2698 209.556 67.1284C207.426 68.987 204.94 70.3967 202.248 71.2729C199.556 72.149 196.714 72.4734 193.893 72.2265C191.071 71.9797 188.329 71.1667 185.83 69.8365C183.332 68.5063 181.128 66.6863 179.353 64.486C177.578 62.2858 176.268 59.7508 175.501 57.0335C174.735 54.3162 174.527 51.4728 174.892 48.6743C176.486 30.4578 198.606 16.425 198.606 16.425C198.606 16.425 218.289 34.1151 216.695 52.3316Z",
    fill: "#77D3FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11304_9724)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M148.758 25.6347L140.941 21.6327C139.285 20.7852 137.481 20.2661 135.628 20.104C127.698 19.4101 120.706 25.2767 120.012 33.2074L117.89 57.4694C117.06 66.9494 124.073 75.3069 133.553 76.1363L236.544 85.1469C246.024 85.9763 254.382 78.9635 255.211 69.4834L257.334 45.2215C258.028 37.2908 252.161 30.2993 244.23 29.6054C242.378 29.4433 240.511 29.6413 238.733 30.1885L230.34 32.7722C226.05 34.0927 221.414 33.6871 217.419 31.6417L213.326 29.5463C209.33 27.5009 204.694 27.0953 200.404 28.4158L196.009 29.7687C191.72 31.0892 187.084 30.6836 183.088 28.6382L178.995 26.5428C175 24.4974 170.364 24.0918 166.074 25.4123L161.679 26.7652C157.389 28.0857 152.753 27.6801 148.758 25.6347Z",
    fill: "#77D3FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M151.829 39.957L144.012 35.955C142.356 35.1075 140.552 34.5883 138.7 34.4262C130.769 33.7324 123.777 39.599 123.084 47.5296L120.961 71.7916C120.131 81.2717 127.144 89.6292 136.624 90.4586L239.616 99.4691C249.096 100.299 257.453 93.2858 258.282 83.8057L260.405 59.5437C261.099 51.6131 255.232 44.6215 247.302 43.9277C245.449 43.7656 243.582 43.9636 241.805 44.5108L233.411 47.0945C229.121 48.415 224.485 48.0094 220.49 45.964L216.397 43.8686C212.401 41.8232 207.766 41.4176 203.476 42.7381L199.081 44.0909C194.791 45.4115 190.155 45.0059 186.16 42.9605L182.066 40.865C178.071 38.8197 173.435 38.4141 169.145 39.7346L164.75 41.0874C160.46 42.4079 155.825 42.0024 151.829 39.957Z",
    fill: "#77D3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.9 54.2792L147.083 50.2773C145.428 49.4297 143.624 48.9106 141.771 48.7485C133.84 48.0547 126.849 53.9213 126.155 61.8519L124.032 86.1139C123.203 95.594 130.216 103.951 139.696 104.781L242.687 113.791C252.167 114.621 260.524 107.608 261.354 98.128L263.476 73.866C264.17 65.9353 258.304 58.9438 250.373 58.25C248.52 58.0879 246.654 58.2859 244.876 58.833L236.482 61.4167C232.193 62.7372 227.557 62.3317 223.561 60.2863L219.468 58.1908C215.473 56.1454 210.837 55.7399 206.547 57.0604L202.152 58.4132C197.862 59.7337 193.226 59.3281 189.231 57.2828L185.138 55.1873C181.142 53.1419 176.506 52.7363 172.217 54.0569L167.822 55.4097C163.532 56.7302 158.896 56.3246 154.9 54.2792Z",
    fill: "#A1E1FB"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M183.689 52.9565C183.72 54.7303 184.705 58.8094 188.396 60.9356",
    stroke: "white",
    strokeWidth: 4.84615,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M185.069 43.3486C185.069 43.3486 184.486 43.8381 184.392 44.9109",
    stroke: "white",
    strokeWidth: 4.84615,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11304_9724)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2875 115.74C93.7009 118.532 93.5433 121.378 92.8241 124.109C92.105 126.839 90.8391 129.396 89.1027 131.627C87.3663 133.858 85.1953 135.716 82.7203 137.09C80.2452 138.463 77.5172 139.324 74.7005 139.62C71.8837 139.916 69.0364 139.642 66.3299 138.812C63.6233 137.983 61.1133 136.617 58.9511 134.796C56.7888 132.975 55.0189 130.737 53.7478 128.216C52.4767 125.695 51.7307 122.943 51.5546 120.126C49.6432 101.94 68.68 83.9445 68.68 83.9445C68.68 83.9445 91.3761 97.554 93.2875 115.74Z",
    fill: "#D9F2FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11304_9724",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 83,
    width: 43,
    height: 57
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2865 115.74C93.6999 118.532 93.5423 121.378 92.8231 124.109C92.104 126.839 90.8381 129.396 89.1017 131.627C87.3654 133.858 85.1943 135.716 82.7193 137.09C80.2442 138.463 77.5162 139.324 74.6995 139.62C71.8828 139.916 69.0355 139.642 66.3289 138.812C63.6223 137.983 61.1124 136.617 58.9501 134.796C56.7878 132.975 55.0179 130.737 53.7468 128.216C52.4757 125.695 51.7297 122.943 51.5537 120.126C49.6423 101.94 68.679 83.9445 68.679 83.9445C68.679 83.9445 91.3751 97.554 93.2865 115.74Z",
    fill: "#77D3FA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11304_9724)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M21.5039 102.497L13.0666 100.06C11.2798 99.5443 9.40991 99.3789 7.56022 99.5733C-0.357122 100.405 -6.1008 107.498 -5.26866 115.416L-2.7229 139.637C-1.72818 149.101 6.75042 155.967 16.2146 154.972L119.033 144.166C128.497 143.171 135.363 134.692 134.368 125.228L131.822 101.007C130.99 93.0895 123.897 87.3458 115.98 88.178C114.13 88.3724 112.336 88.9229 110.695 89.7992L102.949 93.937C98.9898 96.0518 94.3617 96.5382 90.0494 95.2928L85.6316 94.0169C81.3193 92.7714 76.6913 93.2578 72.7322 95.3727L68.6762 97.5392C64.7171 99.654 60.089 100.14 55.7767 98.895L51.3589 97.6191C47.0466 96.3736 42.4185 96.8601 38.4594 98.9749L34.4034 101.141C30.4443 103.256 25.8162 103.743 21.5039 102.497Z",
    fill: "#77D3FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M27.251 115.969L18.8137 113.532C17.0268 113.016 15.157 112.851 13.3073 113.045C5.38995 113.877 -0.353733 120.97 0.478413 128.887L3.02417 153.109C4.01889 162.573 12.4975 169.439 21.9617 168.444L124.78 157.637C134.244 156.643 141.11 148.164 140.115 138.7L137.569 114.479C136.737 106.561 129.644 100.817 121.727 101.65C119.877 101.844 118.083 102.395 116.442 103.271L108.696 107.409C104.737 109.523 100.109 110.01 95.7965 108.764L91.3787 107.489C87.0664 106.243 82.4383 106.73 78.4792 108.844L74.4232 111.011C70.4641 113.126 65.8361 113.612 61.5238 112.367L57.106 111.091C52.7937 109.845 48.1656 110.332 44.2065 112.447L40.1505 114.613C36.1914 116.728 31.5633 117.214 27.251 115.969Z",
    fill: "#77D3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.999 129.443L24.5617 127.006C22.7749 126.49 20.905 126.324 19.0553 126.519C11.138 127.351 5.39431 134.444 6.22646 142.361L8.77221 166.582C9.76694 176.046 18.2455 182.912 27.7097 181.918L130.528 171.111C139.992 170.116 146.858 161.638 145.863 152.173L143.317 127.952C142.485 120.035 135.392 114.291 127.475 115.123C125.625 115.318 123.831 115.868 122.19 116.745L114.444 120.882C110.485 122.997 105.857 123.484 101.545 122.238L97.1268 120.962C92.8145 119.717 88.1864 120.203 84.2273 122.318L80.1713 124.485C76.2122 126.599 71.5841 127.086 67.2718 125.84L62.854 124.564C58.5417 123.319 53.9136 123.805 49.9545 125.92L45.8985 128.087C41.9394 130.202 37.3113 130.688 32.999 129.443Z",
    fill: "#A1E1FB"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0052 122.651C61.3743 124.386 63.1196 128.202 67.1483 129.585",
    stroke: "white",
    strokeWidth: 4.84615,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5273 112.955C60.5273 112.955 60.0481 113.547 60.1607 114.618",
    stroke: "white",
    strokeWidth: 4.84615,
    strokeLinecap: "round"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21L41 29",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M231 27L252.5 21",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M231 113L247 119",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11304_9724"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.881,
    y: 14,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(5 170.881 14)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11304_9724"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 86.8535,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-6 41 86.8535)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrinking);
export default __webpack_public_path__ + "static/media/water-drinking.67133fe411b08ed6ace08f636e208c0b.svg";
export { ForwardRef as ReactComponent };